<template>
    <div class="card marginL201 clearfix">
        <div class="login-title h50">
            <span></span>
            发布公告
        </div>
        <div class="card-wrap fl" >
            <div>
                <img src="../../../images/gonggao.png" alt="">
            </div>
            <div style="margin-top:20px;">
                <div>
                    <span class="card-item-title" style="font-weight: bold;">我的公告</span>
                    <span style="font-size: 14px;color:#fb5858;margin-left:20px;">(已发布于{{createTime}})</span>
                </div>
                <el-input
                          type="textarea"
                          style="font-size: 14px;color:#EAEAEA;margin-top:10px;"
                          :maxlength=500
                          class="card-textarea w600 h140  fontSize14" v-model="noticeContent"/>
            </div>
            <div style="margin-top:10px;">
                <p style="font-size: 14px;color:#999999;">（字数限制500字以内）</p>
            </div>
            <div class="check-data">
            <label class="searchTips">公告展示有效期:</label>
            <el-date-picker
                    v-model="startTime"
                    type="date"
                    placeholder="开始日期"
                    :editable=false
                   >
            </el-date-picker>
            -
            <el-date-picker
                    v-model="endTime"
                    type="date"
                    :editable=false
                    placeholder="结束日期"
                    >
            </el-date-picker>
        </div>
            <div class="check-data">
                <label class="searchTips">群发给关注您的所有患者:</label>
                <el-radio class="radio " v-model="isPush" label="1">群发</el-radio>
                <el-radio class="radio " v-model="isPush" label="2">不群发</el-radio>
            </div>
            <div class="btn-wrap marginT45 marginB30">
                <el-button type="primary" class=" btn h36 w140" @click="linkToPersonalPage">
                    确认发布
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import axiosUtil from "../../utils/AxiosUtils.js"
    import { Message,MessageBox, Loading } from "element-ui";
    import { formatUnixTime} from "../../utils/DateFormat.js";
    import html2Escape from "../../utils/Html2Escape"
    import Vue from "vue";
    Vue.use(Loading);
    export default{
        data: function(){
            return{
                isSubmit: false,//是否提交成功
                docInfo: {},//医生详情
                endTime: "",
                startTime: "",
                noticeContent: "",
                isPush:"1",
                createTime:""
            }
        },
        mounted: function () {
            this.getConsultDetail();
        },
        methods:{
            linkToPersonalPage:function(){
                MessageBox.confirm('确认发布公告?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let _this=this;
                    let options={
                        Service:"nethos.doc.notice.add",
                        noticeContent:_this.noticeContent,
                        isPush:_this.isPush=="1"?true:false,
                        startTime:_this.startTime,
                        endTime:_this.endTime,
                        token: localStorage.getItem("token"),
                    }
                    axiosUtil(options,function(data){
                        
                        Message({
                            showClose: true,
                            message: "发布成功",
                            type: "success"
                        });
                    })
                }).catch(() => {

                });
            },
            getConsultDetail:function(){
                let _this=this;
                let options={
                  Service:"nethos.doc.notice.get",
                  token: localStorage.getItem("token"),
              }
              axiosUtil(options,function(data){
                  
                  if(data.obj.expired){
                      _this.createTime="公告已过期"
                  }else{
                      _this.createTime=formatUnixTime(data.obj.createTime);
                  }
                  if(data.obj.noticeContent){
                      _this.noticeContent=data.obj.noticeContent;
                  }else{
                      _this.noticeContent=""
                  }
              })
            },
        }
    }
</script>
